import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { useCallback as m } from "react";
import { ILLUSTRATIONS as c } from "../../../assets/illustrations/illustrations.js";
import d from "../buttons/button/button.js";
import h from "../image/image.js";
import i from "../layout/flex-view.js";
import n from "../text/text.js";
const $ = ({ height: a, onTryAgain: t, theme: l = "light" }) => {
  const s = m(() => {
    t ? t() : window.location.reload();
  }, [t]), e = l === "dark" ? "WHITE_T_87" : "BLACK_T_87";
  return /* @__PURE__ */ o(i, { $alignItems: "center", $justifyContent: "center", $height: a, children: [
    /* @__PURE__ */ r(
      i,
      {
        $widthX: 22.5,
        $heightX: 11.5,
        $borderRadiusX: 1,
        $marginBottomX: 1.5,
        $background: "GREY_1",
        $justifyContent: "center",
        $alignItems: "center",
        children: /* @__PURE__ */ r(h, { width: 122, height: 100, src: c.ROCKET_BROKEN, withLoader: !1 })
      }
    ),
    /* @__PURE__ */ r(n, { $renderAs: "h4", $marginBottomX: 0.5, $color: e, children: "Oops! Looks like something went wrong" }),
    /* @__PURE__ */ o(n, { $renderAs: "body2", $align: "center", $marginBottomX: 1.5, $color: e, children: [
      "Please try again. Alternatively if that does not work,",
      /* @__PURE__ */ r("br", {}),
      " please contact support."
    ] }),
    /* @__PURE__ */ r(
      d,
      {
        label: "Try again",
        onClick: s,
        renderAs: "primary",
        size: "small",
        widthX: 14
      }
    )
  ] });
}, T = $;
export {
  T as default
};
//# sourceMappingURL=error.js.map
